var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtraLargeBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1027 136.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-extra-large-blue {\n        fill: #1c4f96;\n      }\n\n      .cls-extra-large-blue, .cls-extra-large-blue2 {\n        stroke-width: 0px;\n      }\n\n      .cls-extra-large-blue2 {\n        fill: #36c;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Active_Click_",
    "data-name": "Active (Click)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-extra-large-blue2",
    d: "M1025.39,60.68c5.01-16.6-2.25-38.67-23.89-48.48,0,0,0,0,.01.01-3.43-1.41-7.32-2.71-11.24-3.7.05,0,.11.01.16.02-.66-.16-1.35-.34-2.02-.49.01,0,.03,0,.04.01-.01,0-.03,0-.04,0,0,0,.01,0,.02,0,0,0,0,0-.01,0,0,0,0,0,0,0-.12-.03-.23-.05-.37-.08h0s0,0,0,0h0s0,0-.01,0h.01s-.03,0-.04,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.01,0-3.25-.72-6.47-1.33-9.81-1.93.51.09,1.02.17,1.53.26-.11-.02-.21-.04-.31-.06.11.02.21.04.31.05-.26-.04-.5-.09-.76-.13.25.04.5.09.76.13-.34-.06-.67-.12-1.01-.17.34.06.67.12,1.01.17-19.22-3.24-39.58-1.98-59.27-2.87.11,0,.22,0,.33,0C634.99,1.45,347.98-4.16,62.83,5.47c0,0,.02,0,.03-.01-6.92.88-13.8,1.75-20.54,3.04.03,0,.05,0,.08,0-7.21,1.6-15.94,2.55-22.33,5.76,0,0,0,0,0,0-3.43,2.2-6.75,4.41-9.8,6.8.24-.2.56-.39.76-.59-14.89,11.91-16.22,84.51,5.37,93.61,0,0,0,0,0,0,.54.35,1.15.7,1.73,1.05-.02,0-.04,0-.06,0,42.47,17.76,97.54,13.26,145.93,14.34,154.12,1.19,305.9-.56,461.16.16,115.85-7.34,274.71,24.5,376.06-7.12-.02.03,10.19-5.19,10.17-5.16,2.63-5.16,7.48-9.86,9.64-15.12h0s.03-.05.05-.08c0,0-.01.01-.01.02,0,0,.02-.02.02-.03,0,0,0,.01,0,.01,6.41-13.5,7.21-27.63,4.3-41.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-extra-large-blue",
    d: "M987.66,7.88c.05.01.11.02.16.04-.09-.02-.18-.04-.26-.06,0,0,0,0,0,0,0,0,0,0,0,0,.02.01.06.02.1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-extra-large-blue",
    d: "M12.85,15.67s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-extra-large-blue",
    d: "M988.14,7.99s-.05-.01-.08-.02c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.03,0,.05,0,.08.02Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraLargeBg);
export default __webpack_public_path__ + "static/media/extra-large-bg.96726514130b519762f0cdccb735dd2d.svg";
export { ForwardRef as ReactComponent };